export default class RentCalc {
  constructor() {
    this.formEl = document.querySelector('.js-rent-form');
    if (! this.formEl) return;

    this.inputs = this.formEl.querySelectorAll('input');
    this.selects = this.formEl.querySelectorAll('select');
    if (! (this.inputs.length > 0 && this.selects.length > 0)) return;

    this.dateInputs = this.formEl.querySelectorAll('input[type="date"]');
    this.transportSelect = this.formEl.querySelector('select[name="rent-transport-type"]');
    if (this.transportSelect) {
      this.addressInput = this.transportSelect.parentElement.querySelector('#rent-transport-address');
      this.postCodeInput = this.transportSelect.parentElement.querySelector('#rent-transport-post');
      this.cityInput = this.transportSelect.parentElement.querySelector('#rent-transport-city');
    }
    // if (! (this.dateInputs || this.transportSelect || this.addressInput)) return;

    this.daysOutput = this.formEl.querySelector('.js-rent-form-days');
    this.priceOutput = this.formEl.querySelector('.js-rent-form-price');
    this.depositOutput = this.formEl.querySelector('.js-rent-form-deposit');
    this.transportOutput = this.formEl.querySelector('.js-rent-form-transport')
    this.sumOutput = this.formEl.querySelector('.js-rent-form-sum');
    // if (! (this.daysOutput || this.priceOutput || this.depositOutput || this.transportOutput || this.sumOutput)) return;

    this.debounceTimer;
    this.isLoading = false;
    this.actionAJAX = 'get_distance';
    this.postCodeRegex = /^\d{2}-\d{3}$/;
    this.cityRegex = /^[a-zA-Z]+$/;
    this.currencyFormat = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' });
    this.pricePerDay = parseFloat(this.formEl.dataset.price);
    this.priceDeposit = parseFloat(this.formEl.dataset.deposit);
    this.pricePerKM = parseFloat(this.formEl.dataset.priceTransport);
    this.days = 0;
    this.distance = 0;

    this._bindEvents();

    this.init();
  }
  _bindEvents() {
    this.formEl.addEventListener('input', event => {
      if (this.isLoading) return; // disable while waiting for ajax
      // console.log(event.target.type);
      if (event.target.type === 'date') {
        if (! (this.dateInputs.length > 0)) return;
        this.dateInputs.forEach(dateInput => {
          if (event.target != dateInput) {
            if (dateInput.name.includes('start')) {
              dateInput.setAttribute('max', event.target.value);
            }
            else if (dateInput.name.includes('end')) {
              dateInput.setAttribute('min', event.target.value);
            }
          }
        });
        this.getDaysCount();
      }
      else if (event.target.type === 'text') {
        if ((this.postCodeInput && event.target === this.postCodeInput) || (this.cityInput && event.target === this.cityInput)) {
        // if (this.addressInput && event.target === this.addressInput) {
          if (this.validatePostcodeCity()) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
              this.postCodeInput.disabled = true;
              this.cityInput.disabled = true;

              this.getTransportPrice(true);

              this.postCodeInput.disabled = false;
              this.cityInput.disabled = false;
            }, 1000);
          }
        }
      }
      else {
        this.selects.forEach(select => {
          if (event.target === select) {
            this.toggleOptionalVisibility(select);
            return;
          }
        });
      }
    })
  }
  init() {
    this.selects.forEach(select => {
      this.toggleOptionalVisibility(select);
    });
    if (this.dateInputs.length > 0) {
      this.getDaysCount();
    }
    if (this.postCodeInput && this.cityInput) {
    // if (this.addressInput) {
      if (this.validatePostcodeCity(false)) {
        this.getTransportPrice();
      }
    }
  }
  getDaysCount() {
    if (this.dateInputs[0].value && this.dateInputs[1].value) {
      let difference = new Date(this.dateInputs[1].value) - new Date(this.dateInputs[0].value);
      this.days = Math.ceil(difference / (1000 * 60 * 60 * 24));
      this.days = (this.days < 0) ? 1 : this.days + 1; 
      this.daysOutput.lastElementChild.innerHTML = `${this.days} ${this.days === 1 ? 'dzień' : 'dni'}`;
      this.priceOutput.lastElementChild.innerHTML = this.currencyFormat.format(this.pricePerDay * this.days) + ' brutto';

      this.getSum();
    }
  }
  validatePostcodeCity(mark = true) {
    let valid = true;

    if (this.postCodeInput) {
      if (this.postCodeInput.value.length >= 6 && this.postCodeRegex.test(this.postCodeInput.value)) {
        if (mark) this.postCodeInput.parentElement.classList.remove('invalid');
      } else {
        if (mark) this.postCodeInput.parentElement.classList.add('invalid');
        valid = false;
      }
    }

    if (this.cityInput) {
      if (this.cityInput.value.length >= 2 && this.cityRegex.test(this.cityInput.value)) {
        if (mark) this.cityInput.parentElement.classList.remove('invalid');
        console.log(`- postcode valid`);
      } else {
        if (mark) this.cityInput.parentElement.classList.add('invalid');
        valid = false;
        console.log(`- city invalid`);
      }
    }

    return valid;
  }
  async getTransportPrice() {
    // if (this.addressInput.value.length < 5) return;

    this.isLoading = true;
    this.formEl.classList.add('loading');

    let formData = {
      // address: this.addressInput.value,
      city: this.cityInput.value,
      postalcode: this.postCodeInput.value,
    }
    let distance = await this.getDistance(formData);

    this.isLoading = false;
    this.formEl.classList.remove('loading');

    if (! distance) {
      this.distance = 0;
      this.transportOutput.lastElementChild.innerHTML = '-';
      return;
    }
    this.distance = distance;
    let transportPrice = this.pricePerKM * (distance / 1000);
    this.transportOutput.lastElementChild.innerHTML = this.currencyFormat.format(transportPrice) + ' brutto';

    this.getSum();
  }
  async getDistance(formData) {
    let queryString = new URLSearchParams(formData).toString();
    let url = `/wp-admin/admin-ajax.php?action=${this.actionAJAX}&${queryString}`;
    // console.log(url);

    this.formEl.classList.add('loading');

    let response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {},
    })

    this.formEl.classList.remove('loading');

    // console.log(response.status);
    let result = '';
    let responseText = await response.text();
    // console.log(responseText);
    try {
      result = JSON.parse(responseText);
    } catch (e) {
      console.log(e);
      if (response.status === 401) result = { message: 'Unauthorized' }
    }

    console.log(result);
    console.log(`${result.value / 1000}km`);
    return (result.status == 'OK' || result.status == 'CACHE') ? result.value : false;
  }
  getSum() {
    if (this.days) {
      let pricDays = this.pricePerDay * this.days;
      let priceTransport = this.pricePerKM * (this.distance / 1000);
      let total = pricDays + this.priceDeposit + priceTransport;
      this.sumOutput.lastElementChild.innerHTML = this.currencyFormat.format(total);
    }
  }
  toggleOptionalVisibility(select) {
    // let input = select.parentElement.querySelector('input');
    // if (select.value == input.parentElement.parentElement.id) {
    //   input.parentElement.parentElement.classList.remove('hidden');
    //   input.disabled = false;
    //   input.required = true;
    // }
    // else {
    //   input.parentElement.parentElement.classList.add('hidden');
    //   input.disabled = true;
    //   input.required = false;
    //   input.value = null;

    //   console.log(select.name);
    //   if (select.name == 'rent-transport-type') {
    //     this.transportOutput.lastElementChild.innerHTML = '-';
    //     this.distance = 0;
    //     this.getSum();
    //   }
    // }
    let children = select.parentElement.querySelectorAll('input');
    children.forEach(input => {
      if (select.value == input.parentElement.parentElement.id) {
        input.parentElement.parentElement.classList.remove('hidden');
        input.disabled = false;
        input.required = true;
      }
      else {
        input.parentElement.parentElement.classList.add('hidden');
        input.disabled = true;
        input.required = false;
        input.value = null;

        if (select.name == 'rent-transport-type') {
          this.transportOutput.lastElementChild.innerHTML = '-';
          this.distance = 0;
          this.getSum();
        }
      }
    });
  }
}
